import React, {useState} from 'react'
import {motion} from 'framer-motion'
import { HiChevronLeft, HiChevronRight } from 'react-icons/hi'

import { AppWrap, MotionWrap } from '../../wrapper'
import testimonialData from './TestimonialData'
 
import './Testimonial.scss'
import brandsData from './BrandsData'


const Testimonial = () => {
  const [brands, setBrands] = useState(brandsData)
  const [testimonials, setTestimonials] = useState(testimonialData)
  const [currentIndex, setCurrentIndex] = useState(0)

  const handleClick = (index) => {
    setCurrentIndex(index)
  }
 

  const mmdata = testimonials[currentIndex]

  

  return (
    <>
      {testimonials.length && (
        <>
    
        
          <div className='app__testimonial-item app__flex'>
            <img src={mmdata.imgUrl} alt={mmdata.name}/>
            <div className='app__testimonial-content'>
              <p className='p-text'>{mmdata.feedback}</p>
              <div>
                <h4 className='bold-text'>{mmdata.name}</h4>
                <h5 className='p-text'>{mmdata.designation}</h5>
              </div>

            </div>
          </div>
     

          <div className='app__testimonial-btns app__flex'>
            <div className='app__flex' onClick={()=> handleClick(currentIndex === 0 ? testimonials.length -1 : currentIndex -1)}>
              <HiChevronLeft />
            </div>

            <div className='app__flex' onClick={()=> handleClick(currentIndex === testimonials.length -1 ? 0 : currentIndex + 1)}>
              <HiChevronRight />
            </div>
          </div>
        </>
      )}


      <div className='app__testimonial-brands app__flex'>
        {
          brands.map((brand) => (
            <motion.div
            whileInView={{opacity: [0,  1]}}
            transition={{duration: 0.5, type: 'tween'}}
            key={brand.id}
            >
            
              <img src={brand.imgUrl} alt={brand.name} />

            </motion.div>
          ))
        }
      </div>
    </>
  )
}

export default AppWrap(
  MotionWrap(Testimonial, 'app__testimonial'),
  'testimonial',
  'app__primarybg'
)
